/*
 * Mobile PDP thumbnail strip — reverse sync (swipe hero -> active thumb).
 * ------------------------------------------------------------------
 * Loaded ONLY when the `mobile_pdp_thumbnail_strip` section setting is ON
 * (gated <script> include in snippets/product-template.liquid).
 *
 * When the shopper swipes/advances the main product Splide on mobile, this
 * pushes the newly-active slide's media id into that product's Alpine
 * `currentMediaId`, so the active thumbnail highlight follows the hero.
 * (The forward direction — tap thumb -> move hero — is already handled by
 * the theme's existing mediachange -> splide.go() plumbing.)
 *
 * Scoping / safety:
 *  - Per instance: each slideshow writes ONLY to its own Alpine scope via
 *    Alpine.$data(splideRoot), and we bind ONLY slideshows that actually
 *    render a strip. So quick-buy / multi-product pages can't cross-fire.
 *  - Desktop: the product Splide is destroyed >= 990px, so 'moved' does not
 *    fire from interaction there; we additionally hard-guard on the media
 *    query so we can never write Alpine state at desktop widths.
 *  - The theme destroys the product Splide at the 990px breakpoint with
 *    completely=false (its own SplideProduct handlers rely on surviving that
 *    transition), so our 'moved' handler persists across resize too.
 *  - No edits to global.bundle.js / island-product.bundle.js.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 990px)';
  var BOUND_FLAG = 'mobileStripSyncBound';

  function syncFromSplide(splide, splideRoot) {
    // Hard desktop guard: never touch Alpine state at >= 990px.
    if (window.matchMedia(DESKTOP_MQ).matches) return;
    if (!window.Alpine || typeof window.Alpine.$data !== 'function') return;

    var slides = splide.Components && splide.Components.Slides;
    if (!slides || typeof slides.getAt !== 'function') return;

    var active = slides.getAt(splide.index);
    if (!active || !active.slide) return;

    var mediaId = active.slide.dataset.mediaId;
    if (!mediaId) return;

    var data = window.Alpine.$data(splideRoot);
    if (!data) return;

    var next = Number(mediaId);
    // Guard redundant writes and any feedback loop with the forward path
    // (tap -> currentMediaId -> mediachange -> splide.go() -> 'moved').
    if (data.currentMediaId === next) return;
    data.currentMediaId = next;
  }

  function bind(splideRoot) {
    if (!splideRoot || splideRoot.dataset[BOUND_FLAG] === 'true') return;
    // Only bind slideshows that actually render a strip (toggle scope).
    if (!splideRoot.querySelector('.mobile-pdp-thumbnail-strip')) return;

    var splide = window.slideshows && window.slideshows[splideRoot.id];
    if (!splide || typeof splide.on !== 'function') return;

    splideRoot.dataset[BOUND_FLAG] = 'true';
    splide.on('moved', function () {
      syncFromSplide(splide, splideRoot);
    });
  }

  function bindAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.splide--product');
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  function init() {
    bindAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme creates the Splide instances on DOMContentLoaded; 'load' is a
  // safety net in case init ran before those instances existed. bind() is
  // idempotent (BOUND_FLAG), so re-running is harmless.
  window.addEventListener('load', init);
  // Quick-buy injects product markup (and new slideshows) dynamically.
  document.addEventListener('shapes:productquickbuy:added', function (e) {
    bindAll((e && e.detail && e.detail.container) || document);
  });
})();
